// Dashboard map page logic. Uses the shared EstateMap module (modules/map.js)
// and NatsClient (modules/location.js) — both load in the modules bundle, so we
// run inside $(document).ready (fires after the deferred modules execute).
if (window.location.pathname === "/") {
  $(document).ready(function () {

// Block focus styles (match the Blocks page: highlight selected, dim the rest)
const DASH_BLOCK        = { color: '#2ecc71', weight: 1.5, fillColor: '#2ecc71', fillOpacity: 0.08, opacity: 0.7 };
const DASH_BLOCK_ACTIVE = { color: '#ffffff', weight: 2.5, fillColor: '#2ecc71', fillOpacity: 0.08, opacity: 1 };
const DASH_BLOCK_DIM    = { color: '#2ecc71', weight: 0.8, fillColor: '#000000', fillOpacity: 0.45, opacity: 0.2 };
let dashActiveLayer = null, dashActiveId = null;
let dashSubEnabled = false;          // show sub-blocks?
let dashSubLayer = null;             // leaflet layer for the focused block's sub-blocks
const DASH_SUB_PALETTE = ['#ef4444','#f59e0b','#22c55e','#0ea5e9','#a855f7','#ec4899','#14b8a6','#eab308','#3b82f6','#f97316','#84cc16','#06b6d4','#d946ef','#10b981','#f43f5e','#8b5cf6','#fbbf24','#f87171','#34d399','#60a5fa','#c084fc','#fb923c','#4ade80','#22d3ee','#e879f9'];

function handleMessage(decoded) {
    // console.log(decoded);
    const channel_id = decoded.channel;
    const client_id = decoded.publisher;
    const protocol = decoded.protocol;
    const payload = decoded.payload;
    const device_name = decoded.payload.device_name;
    // const type = decoded.payload.tags?.type;

    const lat = parseFloat(decoded.payload.latitude);
    const lon = parseFloat(decoded.payload.longitude);

    if (lat && lon) {
        updateDeviceMarker(client_id, device_name, lat, lon);
    }
  }
  const deviceMarkers = {};

  function updateDeviceMarker(clientId, deviceName, lat, lng) {
    if (!lat || !lng) return;

    if (deviceMarkers[clientId]) {
      deviceMarkers[clientId].setLatLng([lat, lng]);
    } else {
      const marker = L.marker([lat, lng]).addTo(map);
      marker.bindPopup(`<b>${deviceName}</b>`);
      deviceMarkers[clientId] = marker;
    }
  }

  // const map = L.map("map").setView([5.305746661250153, 100.28930556504586], 18);
  // L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
  //   maxZoom: 22,
  // }).addTo(map);
  // this is neural harvest location
  // Drone-ortho + satellite basemap from the shared EstateMap module.
  const map = L.map("map", { maxZoom: 21 }).setView(EstateMap.DEFAULT_CENTER, 18);
  EstateMap.addBasemap(map).then(function () {
    if (typeof blocksLayer !== 'undefined' && blocksLayer) blocksLayer.bringToFront();
  });

  if (deviceLogs){
    deviceLogs.forEach((log) => {
      const stringValue = log.latest_message?.string_value;
      if (!stringValue) return;
      const data = JSON.parse(stringValue);
      if (!data || !data.latitude || !data.longitude) return;
      const lat = parseFloat(data.latitude);
      const lon = parseFloat(data.longitude);
      const deviceName = log.latest_message.name;
      const clientId = log.latest_message.publisher;
      if (lat && lon) {
        updateDeviceMarker(clientId, deviceName, lat, lon);
      }
    });
  }


  const blockLayerById = {};
  const blocksLayer = L.geoJSON(blocks, {
    style: () => ({ ...DASH_BLOCK }),
    onEachFeature: (feature, layer) => {
      const name = feature?.name ?? 'Unnamed feature';
      const id = feature?.id ?? feature?.properties?.id;
      if (id != null) blockLayerById[id] = layer;
      layer.bindTooltip(name, { permanent: true, direction: 'center', className: 'custom-tooltip' });
      layer.on('mouseover', function () { if (this !== dashActiveLayer && !dashActiveLayer) this.setStyle({ fillOpacity: 0.18, weight: 2 }); });
      layer.on('mouseout',  function () { if (this !== dashActiveLayer && !dashActiveLayer) this.setStyle(DASH_BLOCK); });
      layer.on('click', function (e) {
        L.DomEvent.stopPropagation(e);
        if (this === dashActiveLayer) dashDeselect();
        else dashSelectBlock(feature, this);
      });
    }
  }).addTo(map);

  // ── Focus a block on click (no detail panel) ──
  function dashSelectBlock(feature, layer) {
    blocksLayer.eachLayer(l => l.setStyle(l === layer ? DASH_BLOCK_ACTIVE : DASH_BLOCK_DIM));
    layer.bringToFront();
    dashActiveLayer = layer;
    dashActiveId = feature?.id ?? feature?.properties?.id;
    try { map.fitBounds(layer.getBounds(), { padding: [40, 40], maxZoom: 19 }); } catch (e) {}
    if (dashSubEnabled) loadDashSubs(dashActiveId);
  }
  function dashDeselect() {
    blocksLayer.eachLayer(l => l.setStyle(DASH_BLOCK));
    dashActiveLayer = null; dashActiveId = null;
    clearDashSubs();
  }
  map.on('click', () => { if (dashActiveLayer) dashDeselect(); });

  // ── Sub-blocks toggle (enable to view; planning comes later) ──
  function clearDashSubs() { if (dashSubLayer) { map.removeLayer(dashSubLayer); dashSubLayer = null; } }
  function loadDashSubs(blockId) {
    clearDashSubs();
    if (!blockId) return;
    $.get('/api/block/section/list', { block_id: blockId }).done(function (fc) {
      if (!dashSubEnabled || dashActiveId !== blockId || !fc.features || !fc.features.length) return;
      let i = 0;
      dashSubLayer = L.geoJSON(fc, {
        style: () => { const c = DASH_SUB_PALETTE[i % DASH_SUB_PALETTE.length]; i++; return { color: '#fff', weight: 1.2, fillColor: c, fillOpacity: 0.5, opacity: 0.9 }; },
        onEachFeature: (feat, lyr) => {
          const pr = feat.properties || {};
          const palms = pr.palm_count != null ? ` · 🌴 ${pr.palm_count}` : '';
          lyr.bindTooltip(`${pr.name || ''}${palms}`, { permanent: true, direction: 'center', className: 'custom-tooltip' });
        }
      }).addTo(map);
    });
  }
  $('#dashSubToggle').on('click', function () {
    dashSubEnabled = !dashSubEnabled;
    $('#dashSubSwitch').toggleClass('on', dashSubEnabled);
    if (dashSubEnabled) { if (dashActiveId) loadDashSubs(dashActiveId); }
    else clearDashSubs();
  });
  const LABEL_MIN_ZOOM = 10;
  function updateLabelsVisibility() {
    const show = map.getZoom() >= LABEL_MIN_ZOOM;
    blocksLayer.eachLayer((layer) => {
      const tt = layer.getTooltip && layer.getTooltip();
      if (!tt) return;
      if (show) layer.openTooltip();
      else layer.closeTooltip();
    });
  }

  updateLabelsVisibility();
  map.on('zoomend', updateLabelsVisibility);

  // Handle block selection dropdown using jQuery
  $('.block-select').on('change', function() {
    const selectedBlockId = $(this).val();
    if (selectedBlockId === 'all') {
      dashDeselect();
      map.setView([5.3926745933572935, 102.22839145415885], 18);
    } else {
      blocksLayer.eachLayer((layer) => {
        const feature = layer.feature;
        if (feature.id === selectedBlockId || feature.properties?.id === selectedBlockId) {
          dashSelectBlock(feature, layer);   // focus + (if enabled) load sub-blocks
        }
      });
    }
  });

const client = new NatsClient(handleMessage);
client.connect();


//  let step = 0.00001; // how much to move each time (smaller = finer control)
  

//  this below is for adjusting the overlay position with arrow keys
// document.addEventListener("keydown", (e) => {
//   switch (e.key) {
//     case "ArrowUp":
//       imageBounds[0][0] += step; // move south-west corner north
//       imageBounds[1][0] += step; // move north-east corner north
//       break;
//     case "ArrowDown":
//       imageBounds[0][0] -= step;
//       imageBounds[1][0] -= step;
//       break;
//     case "ArrowLeft":
//       imageBounds[0][1] -= step;
//       imageBounds[1][1] -= step;
//       break;
//     case "ArrowRight":
//       imageBounds[0][1] += step;
//       imageBounds[1][1] += step;
//       break;
//     case "+":
//       step /= 2; // finer adjustments
//       console.log("Step:", step);
//       break;
//     case "-":
//       step *= 2; // coarser adjustments
//       console.log("Step:", step);
//       break;
//   }

//   // Refresh overlay
//   map.removeLayer(overlay);
//   overlay = L.imageOverlay(imageUrl, imageBounds, { opacity: 0.4 }).addTo(map);
//   console.log("Updated bounds:", imageBounds);
// });
// map.fitBounds(imageBounds);
// if ("geolocation" in navigator) {
//   navigator.geolocation.getCurrentPosition(
//     (position) => {
//       const lat = position.coords.latitude;
//       const lng = position.coords.longitude;
//       L.marker([lat, lng])
//         .addTo(map)
//         .bindPopup("📍")
//         .openPopup();
//     },
//     (error) => {
//       console.error("❌ Location access denied or unavailable:", error);
//     }
//   );
// } else {
//   console.error("Geolocation not supported by this browser.");
  });
}
